export default class File {
    url = null;
    new_file_data = null;
    delete_file = false;

    constructor(url) {
        if (url === undefined) {
            url = null;
        }
        this.url = url;
    }

    selectFromLibrary(file) {
        this.url = file.webPath;
        this.new_file_data = file;
        this.delete_file = false;
    }

    reset() {
        this.url = null;
        this.new_file_data = null;
        this.delete_file = true;
    }

    setNewFileData(newImageData) {
        this.new_file_data = newImageData;
    }
}
